import { render, staticRenderFns } from "./point-log-list.vue?vue&type=template&id=0afbceef&scoped=true&"
import script from "./point-log-list.vue?vue&type=script&lang=js&"
export * from "./point-log-list.vue?vue&type=script&lang=js&"
import style0 from "./point-log-list.vue?vue&type=style&index=0&id=0afbceef&prod&lang=scss&"
import style1 from "./point-log-list.vue?vue&type=style&index=1&id=0afbceef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afbceef",
  null
  
)

export default component.exports